import { render, staticRenderFns } from "./ReportingMain.vue?vue&type=template&id=59d3e2a0&scoped=true"
import script from "./ReportingMain.vue?vue&type=script&lang=js"
export * from "./ReportingMain.vue?vue&type=script&lang=js"
import style0 from "./ReportingMain.vue?vue&type=style&index=0&id=59d3e2a0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d3e2a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59d3e2a0')) {
      api.createRecord('59d3e2a0', component.options)
    } else {
      api.reload('59d3e2a0', component.options)
    }
    module.hot.accept("./ReportingMain.vue?vue&type=template&id=59d3e2a0&scoped=true", function () {
      api.rerender('59d3e2a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting-web/ReportingMain.vue"
export default component.exports